const services = [
  {
    icon: "ri-bar-chart-box-line",
    title: "Conseil en gestion",
    description:
      "Accompagnement dans l'organisation et la gestion de l'activité. Mise en place de méthodes adaptées pour optimiser le fonctionnement de votre entreprise.",
  },
  {
    icon: "ri-compass-3-line",
    title: "Conseil stratégique",
    description:
      "Aide à la prise de décision et au développement de l'entreprise. Analyse de votre situation pour définir les meilleures orientations stratégiques.",
  },
  {
    icon: "ri-line-chart-line",
    title: "Optimisation des activités",
    description:
      "Analyse et amélioration des performances. Identification des leviers de croissance et des axes d'amélioration pour renforcer votre compétitivité.",
  },
];

export default function ServicesSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full border border-[#0A2540]/20 text-[#0A2540] text-xs uppercase tracking-widest mb-5">
            Nos Services
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-[#0A2540] leading-tight max-w-xl">
            Expertise &amp; Accompagnement
          </h2>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service) => (
            <div
              key={service.title}
              className="group p-10 rounded-2xl border border-gray-100 bg-white hover:bg-[#0A2540] transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-gray-50 group-hover:bg-white/10 mb-7 transition-colors duration-300">
                <i className={`${service.icon} text-2xl text-[#0A2540] group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#0A2540] group-hover:text-white mb-4 transition-colors duration-300">
                {service.title}
              </h3>
              <p className="text-gray-500 group-hover:text-white/70 text-sm leading-relaxed transition-colors duration-300">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
